if (!customElements.get("search-clear")) {
  class SearchClear extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
    }

    handleClick(event) {
      event.preventDefault();

      document.dispatchEvent(new CustomEvent("predictive-search:clear"));
      document.body.classList.remove("no-scroll");
      // document.querySelector(".header__icon--menu img").style.display = "block"; /* predictive search menu */ 
      document.querySelector("#menu-drawer").style.width = "unset";
      document.querySelector(".search-modal").classList.remove("search-modal-open");
      if (window.matchMedia("(max-width: 767px)").matches) {
        document.querySelector(".search-modal.with-menu-drawer-open").style.background = "none";
      }
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClickRef);
    }

    connectedCallback() {
      this.addEventListener("click", this.handleClickRef);
    }
  }

  customElements.define("search-clear", SearchClear);
}
